export const reportDWHBuilder = (mode, params, props) => {
  const {data, portalState, userData} = props;

  const defaultReport = {
    area: 'SelfCare',
    subArea: 'CcrReport',
    actionType: 'Ban Search Page',
    messageText: '',
    status: '',
    param10: portalState?.customerPhoneNumber ?? '',
    param2: portalState.banNumber ?? '',
    param3: portalState.customerMail ?? '',
    param1: portalState.selectedHetPay ?? '',
    customerName: `${portalState?.firstName} ${portalState?.lastName}` ?? '',
    idNumber: params?.idNumber ?? '',
    subscriber: userData?.selectedSubscriber ?? '',
    crmId: params?.crmId ?? '',
  };
  const reports = {
    DISPLAY_SEARCH_PAGE: {
      status: 'Ongoing',
      messageText: 'Ban Search Page Displayed',
    },
    SEARCH_BUTTON_CLICK: {
      status: 'Ongoing',
      messageText: 'Ban Search Page Button Clicked',
    },
    BAN_NOT_FOUND: {
      status: 'Ongoing',
      messageText: 'Ban Not Found',
    },
    MEMBER_OF_DIFF_ORG: {
      status: 'Ongoing',
      messageText: 'Ban associated with another business account',
    },
    ERROR: {
      status: 'Error',
      messageText: 'General Error',
    },
    SUCCESS: {
      status: 'Completed',
      messageText: 'Success',
    },
  };

  const report = reports[mode] || {};
  return {...defaultReport, ...report};
};
